"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _loadJs = require("../../utils/loadJs");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var NAV_URL = "//s.gyyx.cn/ForComponents/nav.js?temp=".concat(Math.random());
var NAV_MENU = [{
  title: '账号管理',
  children: [{
    name: '完善注册资料',
    url: '//account.gyyx.cn/HaiWai/Account/CompleteInfo'
  }, {
    name: '修改通行证密码',
    url: '//account.gyyx.cn/HaiWai/Account/ChangePassword'
  }, {
    name: '修改游戏密码',
    url: '//account.gyyx.cn/HaiWai/Game/ModifyGamePwd'
  }]
}, {
  title: '充值中心',
  children: [{
    name: '游戏直充',
    url: '//pay.gyyx.cn/haiwai/payGame'
  }, {
    name: '光宇币充值',
    url: '//pay.gyyx.cn/haiwai/payGyb'
  }]
}, {
  title: '兑换中心',
  children: [{
    name: '兑换问道海外版元宝',
    // url: '//change.gyyx.cn/haiwai/change/gyb',
    url: '//billing.gyyx.cn/haiwai/change/gyb'
  }]
}, {
  title: '安全中心',
  children: [{
    name: '我的认证邮箱',
    url: '//security.gyyx.cn/HaiWai/Email'
  }, {
    name: '修改认证邮箱',
    url: '//security.gyyx.cn/HaiWai/ChangeEmail/'
  }, {
    name: '锁定解锁消费',
    url: '//security.gyyx.cn/HaiWai/LockingConsume'
  }, {
    name: '锁定登录游戏',
    url: '//security.gyyx.cn/HaiWai/LockingAccount'
  }, {
    name: '解锁登录游戏',
    url: '//security.gyyx.cn/HaiWai/UnLockAccount'
  }, {
    name: '乾坤锁管理',
    url: '//security.gyyx.cn/HaiwaiEkey/Index/'
  }, {
    name: '手机认证',
    url: '//security.gyyx.cn/HaiWaiMobilePhone/Index/'
  }]
}];
var Index = function Index() {
  var _useState = (0, _react.useState)(NAV_MENU),
    _useState2 = _slicedToArray(_useState, 2),
    menuData = _useState2[0],
    setMenuData = _useState2[1];
  var handleInit = function handleInit() {
    (0, _loadJs.loadJs)({
      src: NAV_URL,
      cb: function cb() {
        var data = window.navData;
        setMenuData(data);
      }
    }).catch(function (res) {
      console.log('error', res);
    });
  };
  /**
   * 首次加载时，进行初始化的内容
   */
  (0, _react.useEffect)(function () {
    handleInit();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_nav_wrap"
  }, menuData === null || menuData === void 0 ? void 0 : menuData.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gy_nav_item",
      key: item.title
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gy_nav_title"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gy_nav_title_line"
    }), /*#__PURE__*/_react.default.createElement("h2", null, /*#__PURE__*/_react.default.createElement("b", null, "-"), item.title)), /*#__PURE__*/_react.default.createElement("ul", {
      className: "gy_nav_list"
    }, item.children.map(function (ele) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: ele.name
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: ele.url
      }, ele.name));
    })));
  }));
};
var _default = Index;
exports.default = _default;